/**
 * Type-safe Object.values
 */
export function objectValues(object) {
  return Object.values(object);
}